module.exports = __webpack_public_path__ + "static/media/a2censo-logo.8ff24b98.png";